export default __webpack_public_path__ + "static/media/wwf_big.afdd23c6.jpg";